'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _camelCase2 = require('lodash/camelCase');

var _camelCase3 = _interopRequireDefault(_camelCase2);

var _desc, _value, _class;

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _qim = require('qim');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var BaseReducer = (_class = function () {
  function BaseReducer(_ref) {
    var _ref$apiConstants = _ref.apiConstants,
        apiConstants = _ref$apiConstants === undefined ? [] : _ref$apiConstants,
        constants = _ref.constants,
        initialState = _ref.initialState,
        _ref$mainReducer = _ref.mainReducer,
        mainReducer = _ref$mainReducer === undefined ? function (state) {
      return state;
    } : _ref$mainReducer;
    (0, _classCallCheck3.default)(this, BaseReducer);

    this._apiConstants = apiConstants;
    this._constants = constants;
    this._initialState = initialState;
    this._mainReducer = mainReducer;
    this._bindConstants(this._apiConstants);
    this._bindConstants(this._constants);
    this.RESET = this.reset;
  }

  (0, _createClass3.default)(BaseReducer, [{
    key: '_bindConstants',
    value: function _bindConstants(constants) {
      var _this = this;

      (0, _entries2.default)(constants).map(function (_ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        var method = _this[(0, _camelCase3.default)(key)];
        if (method) {
          _this[value] = method;
        }
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      return this._initialState;
    }
  }, {
    key: '_reorder',
    value: function _reorder(_ref4) {
      var action = _ref4.action,
          state = _ref4.state,
          orderFieldName = _ref4.orderFieldName,
          activeOrderFieldName = _ref4.activeOrderFieldName;

      return (0, _qim.update)([[orderFieldName, action.name, (0, _qim.$apply)(function (stateOrder) {
        return state[activeOrderFieldName] === action.name ? stateOrder === 'asc' ? 'desc' : 'asc' : stateOrder;
      })], [activeOrderFieldName, (0, _qim.$set)(action.name)]], this._mainReducer(state, action));
    }
  }, {
    key: 'reducer',
    value: function reducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._initialState;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this[action.type] ? this[action.type]({ state: state, action: action }) : this._mainReducer(state, action);
    }
  }]);
  return BaseReducer;
}(), (_applyDecoratedDescriptor(_class.prototype, 'reducer', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reducer'), _class.prototype)), _class);
exports.default = BaseReducer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/BaseReducer.js
// module id = 872
// module chunks = 1